const defaultAuth = {
  has_business: false,
  first_business: null,
};
export const hasMultipleBusinesses = (user = defaultAuth) =>
  user.has_business && !user.first_business;

export const hasAnyBusinesses = (user = defaultAuth) => user.has_business;
